module.exports = __webpack_public_path__ + "1792771649312/fonts/Urbanist-Light.d7cc498.ttf";